import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'OJ Auto Group — Towing & Car Rental';
render(<App data-id="element-117" />, document.getElementById('root'));